import Error from 'components/alerts/Error';
import Success from 'components/alerts/Success';

import { Text } from 'components/common/form/modules/input/Text';
import { API_ENDPOINTS, fetchAPI } from 'components/graphql/FetchApi'
import { findOrderByCode, refundOrder, resendOrderEmail } from 'components/graphql/queries'
import { closeModal } from 'components/modal/modules/dispatcher/methods';

import React, { useCallback, useEffect, useState, } from 'react'
import { connect } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import UserDucks from 'stores/ducks/User.duck';

const OrderControls: React.FC<{ [label: string]: any }> = (props: any) => {

    const [error, setError] = useState(false)

    const [success, setSuccess] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')

    const [loading, setLoading] = useState(true)

    const [errorMessage, setErrorMessage] = useState('')
    const [order, setOrder] = useState({
        buyerEmail: '',
        buyerName: '',
        buyerPhoneNumber: '',
        orderComponents: [
            { name: '', price: 0, count: 0 }
        ],
        campaign: {
            name: '',
            description: '',
            startTime: {
                year: 0,
                month: 0,
                day: 0,
                hour: 0,
                minute: 0,
                PM: true
            },
            media: {
                logo: ''
            },
            floorplan: {
                labels: [],
                inventoryMap: [],
                height: 0,
                width: 0
            }
        },
        boughtAt: new Date(),
        stripeFee: 0,
        platformFee: 0,
        totalCount: 0,
        subtotal: 0,
        code: '',
        floorplanLocation: null
    })

    const [resendEmail, setResetEmail] = useState('')

    useEffect(() => {
        // params to mutation - order code + inventoryItemId
        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: findOrderByCode,
                variables: {
                    code: props.code
                }
            })
            .then((res) => {
                if (res.data.data.order.findByCode) {
                    setOrder(res.data.data.order.findByCode)
                    setLoading(false)
                } else {
                    setError(true)
                    setErrorMessage('Something went wrong')
                    setLoading(false)
                }
            })
            .catch((err) => {
                setError(true)
                setErrorMessage('Something went wrong')
                setLoading(false)
            })
    }, [props.code, setError, setErrorMessage, setOrder, setLoading, props.reloadData])

    const emailIsValid = (e) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e)
    }

    const resend = useCallback(() => {

        setError(false)
        setErrorMessage('')

        setSuccess(false)
        setSuccessMessage('')

        if (resendEmail === '' || !emailIsValid(resendEmail)) {
            setError(true)
            setErrorMessage('Enter Valid Email')
            return
        }

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: resendOrderEmail,
                variables: {
                    code: order.code,
                    email: resendEmail
                }
            })
            .then((res) => {
                if (res.data.data.order.resendOrderEmail) {
                    props.reloadData()
                    setSuccess(true)
                    setSuccessMessage('Order Confirmation has been sent to ' + resendEmail)
                } else {
                    setError(true)
                    setErrorMessage('Something went wrong')
                }
            })
            .catch((err) => {
                setError(true)
                setErrorMessage('Something went wrong')
            })

    }, [order, resendEmail, emailIsValid, setError, setErrorMessage, props.reloadData])

    const refund = useCallback(() => {

        setError(false)
        setErrorMessage('')

        setSuccess(false)
        setSuccessMessage('')

        fetchAPI
            .post(API_ENDPOINTS.BASE_URL, {
                query: refundOrder,
                variables: {
                    code: order.code,
                }
            })
            .then((res) => {
                if (res.data.data.order.refund) {
                    props.reloadData()
                    setSuccess(true)
                    setSuccessMessage('Order has been refunded')
                } else {
                    setError(true)
                    setErrorMessage('Something went wrong')
                }
            })
            .catch((err) => {
                setError(true)
                setErrorMessage('Something went wrong')
            })

    }, [order, setError, setErrorMessage, props.reloadData])

    if (loading) {
        return <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
            <div className="p-4 w-100 text-center">
                <ClipLoader color={"#000"} loading={true} />
            </div>
        </div>
    }

    return <div style={{ padding: '20px' }}>
        <div style={{ width: '100%', textAlign: 'center' }}>
            <p>
                <span className="ticket-info right">
                    {" "}
                    {order.buyerName}
                </span>
            </p>
            <p>
                <span className="ticket-info right">
                    {" "}
                    {order.buyerEmail}
                </span>
            </p>
            {
                order.buyerPhoneNumber && order.buyerPhoneNumber !== '' ?
                    <p>
                        <span className="ticket-info right">
                            {" "}
                            {order.buyerPhoneNumber}
                        </span>
                    </p> : null
            }
        </div>
        <table className="table">
            <tr>
                <th className="text-left">Item</th>
                <td className="text-center" />
                <th className="text-center">Price</th>
            </tr>
            {
                order.orderComponents.map(component => {
                    return (
                        <tr key={"aaa" + component.name}>
                            <td className="text-left">{component.name} x {component.count}</td>
                            <td className="text-center" />
                            <td className="text-center">
                                ${(component.price / 100).toFixed(2)}
                            </td>
                        </tr>
                    );
                })
            }
            <React.Fragment>
                <tr>
                    <th className="text-left"><b>Subtotal</b></th>
                    <td className="text-center" />
                    <td className="text-center">
                        <b>
                            ${(order.subtotal / 100).toFixed(2)}
                        </b>
                    </td>
                </tr>
                <tr>
                    <th className="text-left">Service Fees</th>
                    <td className="text-center" />
                    <td className="text-center">
                        ${(order.platformFee / 100).toFixed(2)}
                    </td>
                </tr>
                <tr>
                    <th className="text-left">Card Processing Fees</th>
                    <td className="text-center" />
                    <td className="text-center">
                        ${(order.stripeFee / 100).toFixed(2)}
                    </td>
                </tr>
                <tr>
                    <th className="text-left"><b>Total Amount Paid</b></th>
                    <td className="text-center" />
                    <td className="text-center">
                        <b>
                            ${((order.subtotal + order.stripeFee + order.platformFee) / 100).toFixed(2)}
                        </b>
                    </td>
                </tr>
            </React.Fragment>
        </table>
        <div style={{ marginTop: 25, marginBottom: 25 }}>
            <Text
                label='Re-send Order Confirmation to '
                value={resendEmail}
                placeholder={'e-mail'}
                onChange={e => {
                    setResetEmail(e.target.value)
                    setSuccess(false)
                    setError(false)
                    setErrorMessage('')
                    setSuccessMessage('')
                }}
            />
        </div>

        <div style={{ width: '100%', textAlign: 'center', paddingTop: '5px' }}>
            <button className='new-button-blue-outline' onClick={() => resend()}>
                RESEND
            </button>
        </div>
        {
            success ?
                <div>
                    <Success content={successMessage} />
                </div> : null
        }
        {
            error ?
                <div style={{ padding: '20px' }}>
                    <Error content={errorMessage} />
                </div>
                : null
        }
        {
            order.subtotal !== 0 ?
                <div style={{ width: '100%', textAlign: 'center', paddingTop: '20px' }}>
                    <button className='new-button-save' onClick={() => refund()}
                        disabled={success && (successMessage === 'Order has been refunded')}>
                        REFUND
                    </button>
                </div>
                : null
        }
        <div style={{ width: '100%', textAlign: 'center', paddingTop: '10px' }}>
            <button className='new-button-cancel' onClick={() => {
                closeModal()
            }}>
                CANCEL
            </button>
        </div>
    </div>
}

const mapStateToProps = state => ({
    user: UserDucks.getUser(state),
});

export default connect(mapStateToProps)(OrderControls);


// WEBPACK FOOTER //
// ./src/pages/campaign/CampaignsDashboard/OrderControls.tsx